import { createReducer, on, Action } from '@ngrx/store';
import * as actions from '../actions';

export const botflowPlaybackFeatureKey = 'botflowPlaybackState';

export interface BotflowPlaybackState {
  response: string | null;
  loading: boolean;
  error: any;
}

export const initialState: BotflowPlaybackState = {
  response: null,
  loading: false,
  error: null,
};

const botflowPlaybackReducer = createReducer(
  initialState,
  on(actions.openBotflowPlayback, state => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(actions.openBotflowPlaybackSuccess, (state, { response }) => ({
    ...state,
    response,
    loading: false,
  })),
  on(actions.openBotflowPlaybackFailure, (state, { error }) => ({
    ...state,
    error,
    loading: false,
  }))
);

export function reducer(state: BotflowPlaybackState | undefined, action: Action) {
  return botflowPlaybackReducer(state, action);
}
